import {
  ADD_SPACE,
  ELIMINATE_CREDIT_CARD_DEBT,
  EMERGENCY_RESERVE,
  EUROTRIP,
  EXPLORE_INVESTMENTS,
  HOME_IMPROVEMENTS,
  SOLAR_PANELS,
  STUDENT_DEBT
} from '../../../../constants/gems'
import gems from '../../../shared/CashOut/gems'

import HomeImprovement from './HomeImprovement'
import EmergencyReserve from './EmergencyReserve'
import AddSpace from './AddSpace'
import EliminateCreditCardDebt from './EliminateCreditCardDebt'
import StudentDebt from './StudentDebt'
import SolarPanels from './SolarPanels'
import Eurotrip from './Eurotrip'
import ExploreInvestments from './ExploreInvestments'

const props = {
  [EMERGENCY_RESERVE]: EmergencyReserve,
  [HOME_IMPROVEMENTS]: HomeImprovement,
  [ADD_SPACE]: AddSpace,
  [STUDENT_DEBT]: StudentDebt,
  [ELIMINATE_CREDIT_CARD_DEBT]: EliminateCreditCardDebt,
  [SOLAR_PANELS]: SolarPanels,
  [EUROTRIP]: Eurotrip,
  [EXPLORE_INVESTMENTS]: ExploreInvestments
}

export default gems.map(({ key, Gem }) => ({
  ...props[key],
  key,
  Gem: props[key].GemContainer(Gem)
}))
